import React from 'react';
import Image from 'next/image';

type Props = {
  thumbnail: {
    src: string;
    alt: string;
  };
};

export const PlayerPlaceholder: React.FC<Props> = ({ thumbnail }) => (
  <div data-testid="playerPlaceholder">
    <Image
      src={thumbnail.src}
      alt={thumbnail.alt}
      width={1120}
      height={630}
      layout="responsive"
      className="aspect-ratio-16/9"
    />

    <div className="absolute inset-0 flex flex-col justify-center text-center space-y-4 bg-gray-800 bg-opacity-80" />
  </div>
);
